import { enUS, type Locale } from "date-fns/locale";

const formatRelativeLocaleWithoutTime = {
  lastWeek: "'last' eeee",
  yesterday: "'yesterday'",
  today: "'today'",
  tomorrow: "'tomorrow'",
  nextWeek: "eeee",
  other: "PPPP",
};

// need to have a way to remove the time, therefore we use a custom local, and always in english (https://github.com/date-fns/date-fns/issues/1218)
// however there is no way to format the time with the user locale and have english as language therefore we add the time information by ourselves when needed (see toTimeAgo.ts)
export const customLocaleWithoutTime = {
  ...enUS,
  formatRelative: (token: keyof typeof formatRelativeLocaleWithoutTime) => formatRelativeLocaleWithoutTime[token],
} satisfies Locale;
